import React from 'react';
import SoybeanTrading from './soybean';
import CornTrading from './corn';
import WheatTrading from './wheat';

function Material() {
    const handleLogout = (event) => {
        event.preventDefault();
        sessionStorage.clear('token')
        window.location = '/login'
    }

    return (
        <>
            <div className="navbar">
                <a href="/home">
                    <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                </a>
                <button className="logout-btn" onClick={handleLogout}>
                    Log out
                </button>
            </div>
            <div className='trending-body'>
                <div className='trending-soybean'>
                    <SoybeanTrading />
                    <CornTrading />
                    <WheatTrading />
                </div>
            </div>
        </>
    );
}

export default Material;